import React, { useEffect, useRef, useState } from 'react';

function AudioVisualizer({ audioStream, imageSrc }) {
    const audioRef = useRef(null);
    const [isSpeaking, setIsSpeaking] = useState(false);

    useEffect(() => {
        if (audioStream) {
            const audioContext = new AudioContext();
            const analyser = audioContext.createAnalyser();
            const source = audioContext.createMediaStreamSource(audioStream);

            source.connect(analyser);
            analyser.fftSize = 256;

            const dataArray = new Uint8Array(analyser.frequencyBinCount);

            const checkAudioLevel = () => {
                analyser.getByteFrequencyData(dataArray);
                const average = dataArray.reduce((a, b) => a + b, 0) / dataArray.length;

                // Set a threshold for detecting sound
                setIsSpeaking(average > 20);

                requestAnimationFrame(checkAudioLevel);
            };

            checkAudioLevel();

            return () => {
                audioContext.close();
            };
        }
    }, [audioStream]);

    return (
        <div
            className={`profile-container ${isSpeaking ? 'speaking' : ''}`}
            style={{
                display: 'inline-block',
                borderRadius: '50%',
                padding: '10px',
                transition: 'box-shadow 0.3s ease',
                boxShadow: isSpeaking
                    ? '0 0 20px 5px rgba(0, 255, 0, 0.7)' // Glowing effect when speaking
                    : 'none',
            }}
        >
            <img
                src={imageSrc}
                alt="Remote"
                className="profile-picture"
                style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                }}
            />
            <audio autoPlay ref={audioRef} />
        </div>
    );
}

export default AudioVisualizer;